import { useEffect } from 'react';
import { isNil, omit } from 'lodash';
import { useHistory, useLocation } from 'react-router-dom';

export default function useClearRequestedRevision({ loadedRevision }) {
  const history = useHistory();
  const { state } = useLocation();
  const requestedRevision = state?.playbookId;

  // Clearing waits for the new revision to load instead of running in the save callback: until then the
  // unsaved-changes Prompt is mounted, and a replace would ask the user to confirm leaving. This relies on
  // playbookState resetting hasChanges in the same update that changes baseRevisionId.
  useEffect(() => {
    if (isNil(requestedRevision) || isNil(loadedRevision) || loadedRevision === requestedRevision) {
      return;
    }

    history.replace({ ...history.location, state: omit(history.location.state, 'playbookId') });
  }, [history, loadedRevision, requestedRevision]);
}
